import { CustomRenderer } from './CustomRenderer';

export const CustomRendererModule = {
    __init__: ['customRenderer'],
    customRenderer: ['type', CustomRenderer],
};
